// DocsPage.tsx
import {Spin, Button, Typography, message, Empty} from "antd";
import "./styles/styles.less";
import React, {useEffect, useState, useMemo} from "react";
import {useSearchParams} from "react-router-dom";
import {getRequest, getRequestWithParams} from "../../api/httpRequest";
import {docsStore} from "../../store/admissions/docsStore";
import {ContractCard} from "./components/ContractCard";

const {Text} = Typography;

export default function DocsPage() {
    const [searchParams] = useSearchParams();
    const verifypay = searchParams.get("verifypay");
    const {docs, setDocs} = docsStore();
    const [isLoading, setIsLoading] = useState(true);
    const [buttonData, setButtonData] = useState({
        needAdvPmt: false,
        buttonAcces: false,
        textButton: "",
        hintButton: "",
        terminationDateTime: null as string | null,
    });
    const [isButtonLoading, setIsButtonLoading] = useState(true);
    const [isPaying, setIsPaying] = useState(false);

    useEffect(() => {
        const params = verifypay ? {verifypay} : undefined;

        getRequestWithParams("/server/proxy/contracts/getContracts", params)
            .then(response => {
                if (response.data.length > 0) {
                    setDocs(response.data);
                }
            })
            .catch(error => console.error("Failed to load contracts", error))
            .finally(() => setIsLoading(false));

        getRequestWithParams("/server/proxy/contracts/GetButtonAP", params)
            .then(response => {
                setButtonData({
                    needAdvPmt: response.data.NeedAdvPmt,
                    buttonAcces: response.data.ButtonAcces,
                    textButton: response.data.TextButton,
                    hintButton: response.data.HintButton,
                    terminationDateTime: response.data.terminationDateTime,
                });
            })
            .catch(error => console.error("Failed to load button data", error))
            .finally(() => setIsButtonLoading(false));
    }, [verifypay]);

    const isButtonDisabled = useMemo(() => {
        if (!buttonData.needAdvPmt) return true;
        if (!buttonData.buttonAcces) return true;
        if (buttonData.terminationDateTime) {
            const now = new Date();
            const termDate = new Date(buttonData.terminationDateTime);
            if (now > termDate) return true;
        }
        return false;
    }, [buttonData]);

    const handlePayAP = async () => {
        if (isButtonDisabled || isPaying) return;
        setIsPaying(true);
        try {
            const response = await getRequest("/server/proxy/contracts/PayAP");
            if (response.data?.formUrl) {
                window.location.href = response.data.formUrl;
            } else {
                message.error("Не удалось получить ссылку для оплаты");
            }
        } catch (error) {
            message.error("Ошибка при инициализации платежа");
        } finally {
            setIsPaying(false);
        }
    };

    if (isLoading) {
        return (
            <div className="docs-page" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                <Spin />
            </div>
        );
    }

    return (
        <div className="docs-page">
            {!isButtonLoading && buttonData.needAdvPmt && (
            <div className="docs-advance-payment">
                <Button
                    type="primary"
                    onClick={handlePayAP}
                    disabled={isButtonDisabled}
                    loading={isPaying}
                >
                    {buttonData.textButton}
                </Button>
                {buttonData.hintButton && (
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                        {buttonData.hintButton}
                    </Text>
                )}
            </div>
            )}

            <div className="docs-contract-list">
                {docs.length === 0 ? (
                    <div className="docs-empty">
                        <Empty description="Договоры не найдены" />
                    </div>
                ) : (
                    docs.map((doc, index) => (
                        <ContractCard key={doc.contractId || index} doc={doc} />
                    ))
                )}
            </div>
        </div>
    )
}
